import * as DOMPurify from "dompurify"

const About = ({ about }) => {
    let cleanContent = DOMPurify.sanitize(about)

    const createMarkup = (body) => {
        return { __html: body }
    }

    return (
        <section className="relative bg-black px-4 py-8">
            <div className="container mx-auto p-6 px-4">
                <div className="mt-0">
                    <div className="text-white w-full text-xl">
                        <div className="flex justify-between mb-8">
                            <h1 className="text-2xl md:text-3xl lg:text-5xl class-contribution-header font-bold">
                                Class Contributors
                            </h1>
                            {/* <a
                                href="#0"
                                className="read-more-btn py-2 flex self-center w-fit"
                            >
                                <span className="light-blue-dot rounded-full h-4 w-4 mt-1 md:mt-2 mr-2"></span>
                                Read more
                            </a> */}
                        </div>
                        <div
                            dangerouslySetInnerHTML={createMarkup(cleanContent)}
                        ></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
